import moment from 'moment'
import { GetExpertInfoList } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { GetCityFromLocation } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import { IsExpertInfoAdmin } from '@/epp/expertmain/userperm/UserPermUtil'

/**
 * 是否是在休假
 * @param notExtractStartTime 休假开始时间
 * @param notExtractEndTime 休假结束时间
 * @returns
 */
export const IsLeaveRecord = (notExtractStartTime, notExtractEndTime) => {
  const today = moment()
  return (
    today.isSameOrAfter(notExtractStartTime, 'day') &&
    (!notExtractEndTime || today.isSameOrBefore(notExtractEndTime, 'day'))
  )
}

/**
 * 专家表状态
 * state 10 正常 20正在出库 30已出库
 */
export const ExpertState = {
  STATE: {
    IN_SUCCESS: '10',
    OUT_DOING: '20',
    OUT_SUCCESS: '30',
    LEAVE_DOING: '888'
  },
  IF_DELETE: {
    YES: '1',
    NO: '0'
  }
}

/**
 * 专家表构建状态-只用于页面选择
 * state 10 正常  30已出库  888 休假 （该状态不存库，由休假时间判断而来）
 */
export const SelectExpertStateArr = [
  {
    value: '10',
    name: '正常'
  },
  {
    value: '30',
    name: '已出库'
  },
  {
    value: '888',
    name: '休假中'
  }
]

/**
 *
 * @param fromType 功能类型 从哪进来的   STOCK_OUT 出库类型   STOCK_IN 入库类型 EXPERT_LIST 专家列表
 * @constructor
 */

export const ExpertFromType = {
  STOCK_OUT: 'STOCK_OUT',
  STOCK_IN: 'STOCK_IN',
  EXPERT_LIST: 'EXPERT_LIST'
}
/**
 * 获取对应的类型参数
 * @param fromType 功能类型 从哪进来的
 * @constructor
 */
export const ExpertTableArgument = (showTag) => {
  let columns = [
    {
      title: '姓名',
      align: 'left',
      width: '170px',
      scopedSlots: { customRender: 'expertName' }
    },
    {
      title: '年龄',
      align: 'left',
      width: '60px',
      dataIndex: 'expertAge',
    }]
  if (showTag !== '0') {
    columns.push({
      title: '标签',
      align: 'left',
      width: '80px',
      scopedSlots: { customRender: 'tagName' }
    })
  }
  columns = columns.concat([
    {
      title: '手机号',
      align: 'center',
      width: '120px',
      dataIndex: 'mobilePhone'
    },
    {
      title: '区域',
      align: 'left',
      width: '120px',
      dataIndex: 'areaAddressText',
      customRender: (text) => {
        return GetCityFromLocation(text)
      }
    },
    {
      title: '工作单位',
      align: 'left',
      width: '260px',
      scopedSlots: { customRender: 'unitName' },
      dataIndex: 'unitName'
    },
    {
      title: '采购品目',
      align: 'left',
      dataIndex: 'purchaseItem'
    },
    {
      title: '状态',
      align: 'center',
      width: '100px',
      dataIndex: 'stateText'
    },
  ])
  if (IsExpertInfoAdmin()) {
    columns.push({
      title: '操作',
      align: 'center',
      width: '120px',
      scopedSlots: { customRender: 'action' }
    })
  }
  return columns
}

/**
 * 获取列表标签
 * @returns {Promise<*[]>}
 * @constructor
 */
export const GetAllExpertInfoList = async (expertName) => {
  let result = []
  try {
    let res = await GetExpertInfoList(expertName)
    result = res.result || []
  } catch (e) {
    console.log(e.message)
  }
  return result
}

/**
 * 审批状态
 * @type {{getValOrCol(*): {color: (*|string), value: (*|string)}, NORMAL: string[], REDRAW: string[]}}
 */
export const ExpertAuditRecordStatusEnum = {
  // 审批中
  AUDIT_STATE_ING: ['0', '审核中', 'blue'],
  // 审批通过
  AUDIT_STATE_APPROVE: ['1', '审核通过', 'green'],
  // 审批不通过
  AUDIT_STATE_REFUSE: ['2', '审核不通过', 'red'],
  getValOrCol (flag) {
    return getVal(flag, ExpertAuditRecordStatusEnum)
  }
}

/**
 * 获取对应的值和颜色
 * @param flag key值
 * @param enumE 参数对象
 * @returns {{color: (*|string), value: (*|string)}}
 */
export const getVal = (flag, enumE) => {
  let val = Object.keys(enumE).filter((item) => enumE[item][0] === flag)[0]
  return {
    value: val ? enumE[val][1] : '未知状态',
    color: val ? enumE[val][2] : 'red'
  }
}
/**
 * 高级职称
 * @type {string[]}
 */
export const ProfessionalAdvanced = ['1', '2']
/**
 * 中级职称
 * @type {string[]}
 */
export const ProfessionalIntermediate = ['3', '4']
